import React from "react";
import { getBoxColor } from "../Utils/helpers";

export default function BracketMatchBox({
  match,
  existingGame,
  readOnly,
  slug,
  navigate,
  division,
  onCreate,
  topValue,
  matchIndex,
  children,
  matchRefs,
  colorScheme,
}) {
  function handleClick() {
    if (match.isBye) return;

    if (existingGame?.id) {
      const isDashboardRoute =
        window.location.pathname.includes("/dashboard");

      if (isDashboardRoute) {
        navigate(`/dashboard/games/${existingGame.id}`);
      } else if (slug) {
        navigate(`/${slug}/games/${existingGame.id}`);
      } else {
        navigate(`/games/${existingGame.id}`);
      }

      return;
    }

    if (!readOnly && (match.teamA || match.teamB)) {
      if (!division?.bracket_json) {
        alert("Please create and save the bracket first.");
        return;
      }

      onCreate?.(match);
    }
  }

  return (
    <div
      ref={(el) => {
        if (el) {
          matchRefs.current[match.matchId] = el;
        } else {
          delete matchRefs.current[match.matchId];
        }
      }}
      onClick={handleClick}
      className={readOnly ? "public-match-box" : "admin-match-box"}
      style={{
        border: "1px solid black",
        padding: "10px",
        width: "100%",
        minHeight: "72px",
        ...getBoxColor(colorScheme, matchIndex),
        fontStyle: match.isBye ? "italic" : "normal",
        boxSizing: "border-box",
        position: "absolute",
        top: topValue,
        left: 0,
        right: 0,
        margin: "0 auto",
        fontSize: "12px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: match.isBye ? "default" : "pointer",
      }}
    >
      {children}
    </div>
  );
}